<template>
    <div>
        <v-tabs
            v-model="step"
            :fixed-tabs="fixTabs"
            active-class="font-weight-bold tab-active"
            slider-size="2"
            class="position-relative courses-read"
        >
            <div class="hr-base"></div>
            <v-tab href="#1" :class="`tab-header position-relative `" width="10" >
                Acerca del curso
                <!-- <div class="hr-select"></div> -->
            </v-tab>

            <v-tab href="#2" :class="`tab-header position-relative`">
                Currícula
            </v-tab>

        </v-tabs>

        <!-- STEP 1 "generales" -->
        <v-tabs-items v-model="step" class="courses-read">
            <v-tab-item value="1" >
                <v-row class="pt-4">
                    <v-col>
                        <div class="courses-read-title">
                            <p>Resúmen</p>
                        </div>
                        <p>
                            {{ course.summary }}
                        </p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="courses-read-title">
                            <p>Qué vas a aprender</p>
                        </div>
                        <p>
                            {{ course.what_you_will_learn }}
                        </p>
                    </v-col>
                </v-row>
                

            </v-tab-item>

        </v-tabs-items>



        <!-- STEP 2 "Contenido" -->
        <v-tabs-items v-model="step" class="courses-read">
            <v-tab-item value="2">
                <div class="mt-3">
                    <!-- sections -->
                    
                    <v-row v-for="(section, index) in course.sections" :key="index">
                        <v-col cols="px-0 mx-0">
                            <div class="courses-read-title">
                                <p>{{section.title}}</p>
                            </div>
                            <ul class="courses-read-list-item courses-read-list">
                                <div v-for="(lesson, index) in section.lessons" :key="index" class="courses-read-item">
                                    <li ></li><span>{{ lesson.title }}</span>

                                </div>
                            </ul>
                        </v-col>
                    </v-row>
                </div>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['course','fixTabs'],
   
    data(){
        return {
            step: '1',
        }
    },
    watch: {
       
    },
    mounted(){
       
    },
    methods: {
       
       
    }
}
</script>

<style lang="scss">
    
    .position-relative{
        position: relative;
    }

    .hr-base{
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: 0;
        background-color: black;
    }

    .courses-read.v-tabs-items{
        background-color: transparent !important;
    }
    .courses-read .v-tabs-bar{
        background-color: transparent !important;
    }

    .courses-read{

        

        &-main-container{
            display: flex;
            justify-content: space-between;
        }

        &-title{
            font-weight: 800;
            font-size: 0.95rem;
        }


        &-item{
            display: flex;
        }

        &-list{
            padding-left: 30px !important;
            &-item li::marker {
                    font-size: 2rem;
                    color: #18585b;
                    // margin: 10px;
                }
        }
    }
</style>